import React, {useState, useRef} from 'react';
import {Editor} from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import {convertToRaw, EditorState, ContentState} from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {FieldProp} from '../../types';

type WysiwygProps = FieldProp & {};

const getInitialEditorStateFromHtml = (htmlContent: string) => {
    const contentBlock = htmlToDraft(htmlContent || '');
    let initialEditorState = undefined;
    if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        initialEditorState = EditorState.createWithContent(contentState)
    } else {
        initialEditorState = EditorState.createEmpty()
    }
    return initialEditorState;
};

export const Wysiwyg: React.FunctionComponent<WysiwygProps> = ({
                                                                   fieldState,
                                                                   value,
                                                                   displayOnly,
                                                                   onChange,
                                                                   // onBlur,
                                                               }): JSX.Element => {

    const [editorState, setEditorState] = useState<any>(getInitialEditorStateFromHtml(value));
    const emailEditorRef = useRef(null);

    const {
        touched,
        pristine,
        validating,
        valid,
        invalid
    } = fieldState;

    const classNames = [
        'd-print-none',
        touched && 'is-touched',
        pristine && 'is-pristine',
        validating && 'is-validating',
        valid && 'is-valid',
        invalid && 'is-invalid',
    ]
        .filter(Boolean)
        .join(' ');

    const onEditorStateChange = (state: any) => {
        setEditorState(state);
    };

    const handleBlur = (_event: any) => {
        const rawValue = convertToRaw(editorState.getCurrentContent());
        let value = draftToHtml(rawValue);
        if (value === '<p></p>') {
            value = '';
        }

        onChange && onChange(value);
        // onBlur && onBlur(value);
    };

    return (
        <>
            {displayOnly ?
                <div dangerouslySetInnerHTML={{__html: value}}/>
                :
                <div className={classNames}>
                    <Editor
                        ref={emailEditorRef}
                        editorState={editorState}
                        toolbarClassName="descriptionEditorToolbar"
                        wrapperClassName="descriptionEditorWrapper"
                        editorClassName="descriptionEditor"
                        onEditorStateChange={onEditorStateChange}
                        onBlur={handleBlur}
                        toolbar={{
                            options: [
                                'inline', 'fontSize', 'list',
                                'textAlign', 'emoji', 'history'
                            ],
                        }}
                    />
                </div>
            }
        </>
    );
};